import { Controller } from 'stimulus';
import axios from 'axios';
import toArray from '@/helpers/toArray';
import formatPrice from '@/helpers/formatPrice';

class ProductVariantController extends Controller {
  connect() {
    this.currentProductVariantId = parseInt(this.data.get('id'), 10);
  }

  onVariantSelect({ currentTarget }) {
    this.currentProductVariantId = parseInt(currentTarget.value, 10);

    this.updateProductVariant();
  }

  onQuantityChange({ currentTarget }) {
    this.price = parseFloat(this.priceTarget.dataset.price);
    this.priceScheme = JSON.parse(this.priceTarget.dataset.priceSchemes);

    const quantity = parseInt(currentTarget.value, 10);
    const price = this.priceForQuantity(quantity);

    this.updatePrice(price);
  }

  updatePrice(price) {
    this.priceTarget.innerHTML = formatPrice(price);
  }

  priceForQuantity(quantity) {
    if (!this.priceScheme?.length) {
      return this.price;
    }

    const priceScheme = this.priceScheme.find(({ min, max }) => (
      quantity >= min && quantity <= max
    ));

    return priceScheme?.price ?? this.price;
  }

  async updateProductVariant() {
    try {
      const { data } = await axios.get(`/api/product-variant/${this.currentProductVariantId}`);
      const elements = await this.extractReplaces((new DOMParser()).parseFromString(data, 'text/html'));
      await this.replaceElements(elements);
    } catch (error) {
      // console.error(error);
    }
  }

  extractReplaces(document) {
    return new Promise((resolve) => {
      const obj = {};
      const elements = toArray(document.querySelectorAll('[data-replace]'));

      elements.forEach((element) => {
        obj[element.dataset.replace] = element;
      });

      resolve(obj);
    });
  }

  replaceElements(elements) {
    return new Promise((resolve) => {
      Object.keys(elements).forEach((key) => {
        const source = elements[key];
        const destination = document.querySelector(`[data-replace="${key}"]`);

        if (destination) {
          destination.replaceWith(source);
        }
      });

      resolve();
    });
  }
}

ProductVariantController.targets = [
  'price',
];

export default ProductVariantController;
